export default {
  'meta': {
    'langName': 'SPANISH',
    'lang': 'Español'
  },
  'title': 'RECUPERACIÓN DE PRODUCTOS CANASTA DE BALONCESTO B900 BOX NBA TARMAK',
  'description': 'Hemos identificado un riesgo de caída del poste de nuestra canasta de baloncesto B900 si esta se utiliza sin su manivela y se manipula.\nPor su seguridad, detenga inmediatamente todo uso sin su manivela de ajuste de altura instalada.\nLa seguridad de su producto será posible gracias a un sencillo procedimiento y a un kit de reparación que le será entregado gratuitamente.\nEste sitio web dedicado a esta retirada está actualmente en construcción. En él se le indicarán los pasos para realizar esta operación.\nLe informaremos en cuanto esté disponible (durante el mes de julio)',
  'status': 'Translation validated by COUNTRY'
} as const
